import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import AssessmentIcon from "@mui/icons-material/Assessment";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate } from "react-router-dom";
import FeeReceipt from "./FeeReceipt";
import FeeReceiptMultiple from "./FeeReceiptMultiple";
import DailyFeeReport from "./DailyFeeReport";
import DailyFeeReportPerFeeHead from "./DailyFeeReportPerFeeHead";
import FeeConcessionReport from "./FeeConcessionReport";
import DfcReport from "./DfcReport";
import FeeCategory from "../../client/ERPSetup//FeeCategory";
import FeeBook from "../../client/ERPSetup/FeeBook";
import FeeHead from "../../client/ERPSetup/FeeHead";
import FeeConcessionUpload from "../../client/ERPSetup/FeeConcessionUpload";
import FeeConcession from "../../client/ERPSetup/FeeConcession";
import FeePercent from "./FeePercent";
import FeeFineDates from "./FeeFineDates";
import FeeApproval from "../../client/ERPSetup/FeeApproval";
import StudentFeeHistory from "./StudentFeeHistory";
import AttendanceFineRange from "./AttendanceFineRange";
import FeeStructureUpload from "./FeeStructureUpload";
function Fee() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [loading, setLoading] = useState(true);
  const [activeView, setActiveView] = useState("home");
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(2);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  useEffect(() => {
    setLoading(false);
  }, []);

  const getAuthHeaders = () => {
    const token = sessionStorage.getItem("token");
    return {
      Authorization: `Bearer ${token}`,
    };
  };

  const handleNavigate = (path) => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      navigate("/authentication/sign-in");
    } else {
      setActiveView(path);
    }
  };

  const handleBack = () => {
    setActiveView("home");
  };
  const MenuCard = ({ title, icon, path, color = "info", customColor }) => (
    <Grid item xs={12} sm={6} md={4} lg={2.4}>
      <MDButton
        fullWidth
        color={customColor ? "dark" : color}
        variant="gradient"
        size="large"
        startIcon={icon}
        sx={{
          height: 90,
          fontSize: "0.9rem",
          fontWeight: 700,
          borderRadius: "12px",
          color: "#FFFFFF !important",
          background: customColor ? `linear-gradient(135deg, ${customColor}, #6A1B9A)` : undefined,
          boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
          transition: "all 0.25s ease",
          "&:hover": {
            background: customColor
              ? `linear-gradient(135deg, #7B1FA2, ${customColor})`
              : undefined,
            transform: "translateY(-4px)",
            boxShadow: "0 8px 18px rgba(0,0,0,0.22)",
          },
          "& .material-icons-round, & .material-icons": {
            fontSize: "28px",
            color: "#FFFFFF !important",
          },
        }}
        onClick={() => handleNavigate(path)}
      >
        {title}
      </MDButton>
    </Grid>
  );

  MenuCard.propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.node,
    path: PropTypes.string.isRequired,
    color: PropTypes.string,
    customColor: PropTypes.string,
  };
  const renderContent = () => {
    switch (activeView) {
      case "feereceipt":
        return (
          <>
            <FeeReceipt />
          </>
        );
      case "feereceipt-multiple":
        return (
          <>
            <FeeReceiptMultiple />
          </>
        );
      case "feestructure":
        return (
          <>
            <FeeStructureUpload />
          </>
        );
      case "feecategory":
        return (
          <>
            <FeeCategory />
          </>
        );
      case "dailyfeereport":
        return (
          <>
            <DailyFeeReport />
          </>
        );
      case "feeheadreport":
        return (
          <>
            <DailyFeeReportPerFeeHead />
          </>
        );
      case "feeconcessionreport":
        return <FeeConcessionReport />;
      case "dfcreport":
        return (
          <>
            <DfcReport />
          </>
        );
      case "feebook":
        return (
          <>
            <FeeBook />
          </>
        );
      case "upload-feebook":
        return (
          <>
            <FeeBook openUploadOnMount />
          </>
        );
      case "feehead":
        return (
          <>
            <FeeHead />
          </>
        );
      case "feeconcession":
        return (
          <>
            <FeeConcession />
          </>
        );
      case "upload-feeconcession":
        return <FeeConcessionUpload />;
      case "feepercent":
        return <FeePercent />;
      case "feefinedates":
        return <FeeFineDates />;
      case "feeapproval":
        return <FeeApproval />;
      case "studentfeehistory":
        return <StudentFeeHistory />;
      case "attendancefinerange":
        return <AttendanceFineRange />;
      default:
        return (
          <>
            <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                variant="fullWidth"
                TabIndicatorProps={{
                  sx: {
                    backgroundColor: ["#2196F3", "#4CAF50", "#FF9800", "#9C27B0"][tabValue],
                    height: 5,
                    borderRadius: "4px 4px 0 0",
                  },
                }}
              >
                {[
                  {
                    label: "UPLOAD",
                    icon: <CloudUploadIcon />,
                    color: "#2196F3",
                    bgColor: "rgba(33, 150, 243, 0.10)",
                  },
                  {
                    label: "SETUP",
                    icon: <SettingsSuggestIcon />,
                    color: "#4CAF50",
                    bgColor: "rgba(76, 175, 80, 0.10)",
                  },
                  {
                    label: "ACTIONS",
                    icon: <TouchAppIcon />,
                    color: "#FF9800",
                    bgColor: "rgba(255, 152, 0, 0.12)",
                  },
                  {
                    label: "REPORTS",
                    icon: <AssessmentIcon />,
                    color: "#9C27B0",
                    bgColor: "rgba(156, 39, 176, 0.10)",
                  },
                ].map((item, index) => (
                  <Tab
                    key={item.label}
                    icon={item.icon}
                    iconPosition="top"
                    label={
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          gap: 0.2,
                        }}
                      >
                        <Box
                          component="span"
                          sx={{
                            fontSize: "1rem",
                            fontWeight: 600,
                            letterSpacing: "0.1px",
                            lineHeight: 1.5,
                          }}
                        >
                          {item.label}
                        </Box>

                        {tabValue === index && (
                          <KeyboardArrowDownIcon
                            sx={{
                              fontSize: 30,
                              color: item.color,
                              strokeWidth: 2,
                              filter: "drop-shadow(0 1px 1px rgba(0,0,0,0.25))",
                              mt: 0.2,
                            }}
                          />
                        )}
                      </Box>
                    }
                    sx={{
                      minHeight: 105,
                      py: 1.2,
                      fontWeight: 800,
                      color: `${item.color} !important`,
                      opacity: 1,
                      borderRadius: "10px 10px 0 0",
                      transition: "all 0.25s ease",

                      "& .MuiSvgIcon-root": {
                        fontSize: 34,
                        color: item.color,
                        transition: "transform 0.25s ease",
                      },

                      "&:hover": {
                        backgroundColor: item.bgColor,
                        "& > .MuiTab-iconWrapper": {
                          transform: "scale(1.12)",
                        },
                      },

                      ...(tabValue === index && {
                        backgroundColor: item.bgColor,
                        "& .MuiSvgIcon-root": {
                          color: item.color,
                        },
                      }),
                    }}
                  />
                ))}
              </Tabs>
            </Box>

            {/* UPLOADS */}
            {/* UPLOADS */}
            {tabValue === 0 && (
              <Grid container spacing={2}>
                <MenuCard
                  title="UPLOAD FEE STRUCTURE"
                  icon={<Icon>cloud_upload</Icon>}
                  path="feestructure"
                  color="info"
                />
                <MenuCard
                  title="UPLOAD FEE BOOK"
                  icon={<Icon>upload_file</Icon>}
                  path="upload-feebook"
                  color="info"
                />
                <MenuCard
                  title="UPLOAD FEE CONCESSION"
                  icon={<Icon>cloud_upload</Icon>}
                  path="upload-feeconcession"
                  color="info"
                />
              </Grid>
            )}

            {/* SETUP */}
            {/* SETUP */}
            {tabValue === 1 && (
              <Grid container spacing={2}>
                <MenuCard
                  title="FEE CATEGORIES"
                  icon={<Icon>category</Icon>}
                  path="feecategory"
                  color="success"
                />
                <MenuCard
                  title="FEE HEADS"
                  icon={<Icon>account_balance_wallet</Icon>}
                  path="feehead"
                  color="success"
                />
                <MenuCard
                  title="FEE BOOK"
                  icon={<Icon>menu_book</Icon>}
                  path="feebook"
                  color="success"
                />
                <MenuCard
                  title="FEE CONCESSION"
                  icon={<Icon>discount</Icon>}
                  path="feeconcession"
                  color="success"
                />
                <MenuCard
                  title="SET FEE PERCENTAGE"
                  icon={<Icon>percent</Icon>}
                  path="feepercent"
                  color="success"
                />
                <MenuCard
                  title="SET ATTENDANCE FINE"
                  icon={<Icon>payments</Icon>}
                  path="attendancefinerange"
                  color="success"
                />
                <MenuCard
                  title="ASSIGN FINE DATES"
                  icon={<Icon>event</Icon>}
                  path="feefinedates"
                  color="success"
                />
              </Grid>
            )}

            {/* ACTIONS */}
            {/* ACTIONS */}
            {tabValue === 2 && (
              <Grid container spacing={2}>
                <MenuCard
                  title="MULTIPLE FEE RECEIPT"
                  icon={<Icon>receipt_long</Icon>}
                  path="feereceipt-multiple"
                  color="warning"
                />
                <MenuCard
                  title="REQUEST FEE ALLOWED"
                  icon={<Icon>verified</Icon>}
                  path="feeapproval"
                  color="warning"
                />
              </Grid>
            )}

            {/* REPORTS */}
            {/* REPORTS */}
            {tabValue === 3 && (
              <Grid container spacing={2}>
                <MenuCard
                  title="DAILY FEE REPORT"
                  icon={<Icon>assessment</Icon>}
                  path="dailyfeereport"
                  customColor="#9C27B0"
                />

                <MenuCard
                  title="FEE HEAD WISE REPORT"
                  icon={<Icon>summarize</Icon>}
                  path="feeheadreport"
                  customColor="#8E24AA"
                />

                <MenuCard
                  title="FEE CONCESSION REPORT"
                  icon={<Icon>description</Icon>}
                  path="feeconcessionreport"
                  customColor="#7B1FA2"
                />

                <MenuCard
                  title="DFC - DAILY FEE COLLECTION"
                  icon={<Icon>payments</Icon>}
                  path="dfcreport"
                  customColor="#6A1B9A"
                />
                <MenuCard
                  title="STUDENT FEE HISTORY"
                  icon={<Icon>history</Icon>}
                  path="studentfeehistory"
                  customColor="#6A1B9A"
                />
              </Grid>
            )}
          </>
        );
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={2} pb={3}>
        {loading ? (
          <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
            <CircularProgress color="info" />
          </MDBox>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card>
                {/* HEADER - Matching Library Management System card design */}
                <MDBox
                  mx={2}
                  mt={-1}
                  py={1}
                  px={2}
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  flexWrap="wrap"
                  gap={1}
                >
                  <MDBox display="flex" alignItems="center" gap={1}>
                    <Icon sx={{ color: "#FFFFFF" }}>payments</Icon>

                    <MDTypography variant="h6" color="white">
                      FEES
                    </MDTypography>
                  </MDBox>

                  {activeView !== "home" ? (
                    <MDButton
                      variant="contained"
                      onClick={handleBack}
                      startIcon={<Icon>arrow_back</Icon>}
                      sx={{
                        mb: 0,
                        color: "#FFFFFF",
                        backgroundColor: "rgba(255,255,255,0.18)",
                        "&:hover": {
                          backgroundColor: "rgba(255,255,255,0.28)",
                        },
                      }}
                    >
                      Back to Fees
                    </MDButton>
                  ) : (
                    <MDButton
                      variant="contained"
                      onClick={() => navigate("/dashboard")}
                      startIcon={<Icon>dashboard</Icon>}
                      sx={{
                        mb: 0,
                        color: "#FFFFFF !important",
                        backgroundColor: "rgba(255,255,255,0.18) !important",
                        boxShadow: "none !important",
                        "& .material-icons": {
                          color: "#FFFFFF !important",
                        },
                        "&:hover": {
                          color: "#FFFFFF !important",
                          backgroundColor: "rgba(255,255,255,0.28) !important",
                          boxShadow: "none !important",
                        },
                        "&:focus": {
                          color: "#FFFFFF !important",
                          backgroundColor: "rgba(255,255,255,0.18) !important",
                        },
                        "&:active": {
                          backgroundColor: "rgba(255,255,255,0.28) !important",
                        },
                      }}
                    >
                      Dashboard
                    </MDButton>
                  )}
                </MDBox>

                {/* CONTENT */}
                <MDBox p={1}>{renderContent()}</MDBox>
              </Card>
            </Grid>
          </Grid>
        )}
      </MDBox>
      <MDBox display="flex" flexDirection="column" minHeight="50vh"></MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Fee;
